import React, { useState, useEffect } from 'react'
import ProductTabs from './productTabs/productTabs'
import { GetProducts, DeleteProduct } from '../../assets/interfaces/productInterface'
import { GetUserPermissions } from '../../assets/interfaces/uMInterface'
import './productManagementComponent.css'
import { Button, Modal, Box } from '@mui/material'
import ImportIcon from '@mui/icons-material/CloudUpload'
import PricesUpdate from './pricesUpdate/pricesUpdate'
import SyncPriceButton from '../global/SyncPriceButton'
import { useIsProjectEditor } from '../../hooks/useUserPermissions'

function ProductManagementComponent() {
    const [Products, setProducts] = useState([])
    const [SelectedIndex, setSelectedIndex] = useState(0)
    const [IsUserAllowed] = useState(true)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const isProjectEditor = useIsProjectEditor()

    const productMachineTypeName = window.location.pathname.split('/').pop()

    useEffect(() => {
        GetUserPermissions((result) => {
            if (result) {
                //setIsUserAllowed(result.appAccess)
            }
        })
        UpdateProductList()
    }, [])

    useEffect(() => {
        UpdateProductList()
    }, [productMachineTypeName])

    function DeleteCurrentProduct() {
        DeleteProduct(Products[SelectedIndex].id, () => UpdateProductList())
    }

    function UpdateProductList() {
        GetProducts(null, productMachineTypeName, (UpdatedProducts) => {
            setProducts(UpdatedProducts)
            setSelectedIndex(0)
        })
    }

    function onProductUpdate(updatedProduct) {
        setProducts((prevProducts) => prevProducts.map((p) => (p.id === updatedProduct.id ? updatedProduct : p)))
    }

    return (
        <div className='AppContent'>
            {IsUserAllowed ? (
                <>
                    <Box className='ProductHeader'>
                        <h1>Prices - {decodeURIComponent(productMachineTypeName)}</h1>
                        {isProjectEditor && (
                            <>
                                <Button
                                    id={`upload_new_prices_${productMachineTypeName}`}
                                    onClick={() => setIsModalOpen(true)}
                                    component='label'
                                    color='primary'
                                    variant='contained'
                                    size='large'
                                    startIcon={<ImportIcon />}>
                                    Upload new prices
                                </Button>
                                <SyncPriceButton
                                    id={`sync_all_ranges_prices_${productMachineTypeName}`}
                                    builder={productMachineTypeName}
                                    onSyncComplete={UpdateProductList}
                                    initialMessage='Sync all ranges Prices'
                                />
                            </>
                        )}
                    </Box>
                    <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)}>
                        <Box>
                            <PricesUpdate setIsModalOpen={setIsModalOpen} onSuccess={UpdateProductList} />
                        </Box>
                    </Modal>

                    {Products?.length > 0 ? (
                        <ProductTabs
                            builder={productMachineTypeName}
                            Products={Products}
                            SelectedIndex={SelectedIndex}
                            onDeleteProduct={DeleteCurrentProduct}
                            OnSelectedProductChange={(ProdIndex) => setSelectedIndex(ProdIndex)}
                            onProductUpdate={onProductUpdate}
                        />
                    ) : (
                        <h2>No products are available</h2>
                    )}
                </>
            ) : (
                <h1>You are not authorized to see this content</h1>
            )}
        </div>
    )
}

export default ProductManagementComponent
